import { TrainingPlan } from '@/generated';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Stack, Typography } from '@mui/material';
import { isPlanEditor } from './utils';
import { useContext } from 'react';
import { AppContext } from '@/contexts/app.context';
import CreateIcon from '@mui/icons-material/Create';

export const PlanPermissionsElement = (props: { plan?: TrainingPlan }) => {
  const { plan } = props;
  const context = useContext(AppContext);
  const localUser = context.state?.userProfile;

  return (
    <Box sx={{ justifySelf: 'center', marginLeft: 'auto', marginRight: 1 }}>
      {!isPlanEditor(plan, localUser) ? (
        <Stack sx={{ flexDirection: 'row', gap: 1, justifyContent: 'center', alignContent: 'center' }}>
          <Typography sx={{ mx: 1 }}>You have the permission to view this Plan.</Typography>
          <VisibilityIcon />
        </Stack>
      ) : (
        <Stack sx={{ flexDirection: 'row', gap: 1, justifyContent: 'center', alignContent: 'center' }}>
          <Typography sx={{ mx: 1 }}>You have the permission to edit this Plan.</Typography>
          <CreateIcon />
        </Stack>
      )}
    </Box>
  );
};
